export default "__VITE_ASSET__ZgyTyIYD__"